export default function Privacy() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      color: '#e5e7eb',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h1 style={{ fontSize: '32px', fontWeight: 700, marginBottom: '24px' }}>Privacy Policy</h1>
      <p style={{ color: '#9ca3af', marginBottom: '32px' }}>Last Updated: January 2026</p>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>1. Overview</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          UNYKORN ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect,
          use, and safeguard information when you use our Service.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontWeight: 600, color: '#10b981' }}>
          ✅ Key Principle: We never collect or store your wallet seeds or private keys.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>2. Information We Collect</h2>
        
        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>2.1 Wallet Information</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          We may collect public blockchain addresses (r-addresses) that you provide or connect to our Service.
          These are public information on the XRPL blockchain and do not allow us to access your funds.
        </p>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>2.2 Browser Storage</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          When running in a browser context, we use localStorage to store:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>User preferences (theme, language)</li>
          <li style={{ marginBottom: '8px' }}>Public wallet addresses (for convenience)</li>
          <li style={{ marginBottom: '8px' }}>Transaction safety settings (armed/disarmed)</li>
          <li style={{ marginBottom: '8px' }}>Evidence vault document metadata</li>
        </ul>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontSize: '14px', color: '#9ca3af' }}>
          This data never leaves your device and is not transmitted to our servers.
        </p>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>2.3 Xaman xApp Storage</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          When running as a Xaman xApp, we use Xaman's secure userstore API to store the same preferences.
          This data is managed by XRPL Labs and encrypted at rest.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontSize: '14px', color: '#9ca3af', fontStyle: 'italic' }}>
          ℹ️ Note: The userstore is specific to this xApp and your Xaman account. Data is not shared between xApps
          or accessible outside the Xaman ecosystem. UNYKORN cannot access your userstore data directly; it is
          retrieved only when you open the xApp within Xaman.
        </p>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>2.4 Usage Analytics</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          We may collect anonymized usage data including:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>Page views and navigation patterns</li>
          <li style={{ marginBottom: '8px' }}>Feature usage statistics</li>
          <li style={{ marginBottom: '8px' }}>Error logs (no personal data)</li>
          <li style={{ marginBottom: '8px' }}>Performance metrics</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>3. Information We Do NOT Collect</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontWeight: 600, color: '#10b981' }}>
          We explicitly do NOT collect:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>❌ Wallet seeds or private keys</li>
          <li style={{ marginBottom: '8px' }}>❌ Mnemonic phrases</li>
          <li style={{ marginBottom: '8px' }}>❌ Email addresses or personal identification (unless voluntarily provided for support)</li>
          <li style={{ marginBottom: '8px' }}>❌ Financial information beyond public blockchain data</li>
          <li style={{ marginBottom: '8px' }}>❌ Location data</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>4. How We Use Information</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Information we collect is used solely to:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>Provide and improve the Service</li>
          <li style={{ marginBottom: '8px' }}>Remember your preferences across sessions</li>
          <li style={{ marginBottom: '8px' }}>Debug technical issues</li>
          <li style={{ marginBottom: '8px' }}>Analyze usage patterns to enhance user experience</li>
          <li style={{ marginBottom: '8px' }}>Comply with legal obligations</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>5. Third-Party Services</h2>
        
        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>5.1 Xaman (XUMM)</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          When you use Xaman signing, you interact directly with XRPL Labs' services. Please review their
          privacy policy at <a href="https://xaman.app" style={{ color: '#3b82f6' }}>xaman.app</a>.
        </p>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>5.2 XRPL Blockchain</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          All XRPL transactions are public and permanently recorded on the blockchain. Anyone can view transaction
          history associated with public addresses.
        </p>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#60a5fa' }}>5.3 Cloudflare</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Our website may be served through Cloudflare's CDN. They may collect standard web server logs
          (IP addresses, user agents). See Cloudflare's privacy policy for details.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>6. Data Security</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          We implement industry-standard security measures including:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>HTTPS/TLS encryption for all connections</li>
          <li style={{ marginBottom: '8px' }}>No server-side storage of sensitive wallet data</li>
          <li style={{ marginBottom: '8px' }}>Client-side storage encryption when available</li>
          <li style={{ marginBottom: '8px' }}>Regular security audits</li>
        </ul>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontSize: '14px', color: '#fbbf24' }}>
          ⚠️ However, no method of transmission over the Internet is 100% secure. Use at your own risk.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>7. Your Rights</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          You have the right to:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>Access your stored preferences (via browser DevTools → localStorage)</li>
          <li style={{ marginBottom: '8px' }}>Delete all stored data (clear browser storage or xApp storage)</li>
          <li style={{ marginBottom: '8px' }}>Request information about data we may have collected</li>
          <li style={{ marginBottom: '8px' }}>Opt out of analytics (use browser privacy settings)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>8. Data Retention</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Browser localStorage: Persists until you manually clear it.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Xaman userstore: Managed by XRPL Labs; persists per their policies.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Server logs: Retained for 90 days for security and debugging purposes.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>9. Children's Privacy</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Our Service is not intended for users under 18 years of age. We do not knowingly collect information
          from children. If you believe we have inadvertently collected such data, please contact us.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>10. International Users</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Our Service is hosted globally via CDN. By using the Service, you consent to the transfer of your
          information to servers in various jurisdictions. We comply with applicable data protection regulations
          including GDPR where applicable.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>11. Changes to This Policy</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          We may update this Privacy Policy from time to time. Changes will be posted on this page with an
          updated "Last Updated" date. Continued use of the Service constitutes acceptance of the updated policy.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>12. Contact Us</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          For privacy-related questions or to exercise your rights, please contact us through the platform's
          contact form or visit <a href="https://unykorn.org" style={{ color: '#3b82f6' }}>unykorn.org</a>.
        </p>
      </section>

      <div style={{
        marginTop: '48px',
        padding: '24px',
        background: 'rgba(16, 185, 129, 0.1)',
        border: '1px solid rgba(16, 185, 129, 0.2)',
        borderRadius: '12px'
      }}>
        <p style={{ fontSize: '14px', color: '#9ca3af', lineHeight: '1.6' }}>
          <strong style={{ color: '#10b981' }}>Privacy First:</strong> Your wallet security is your responsibility.
          We never have access to your private keys. Always verify transactions before signing, and never share
          your seed phrase with anyone—including UNYKORN staff.
        </p>
      </div>
    </div>
  );
}
